import { func } from "prop-types";

import styled from "styled-components";

import { usePermissions } from "Flocknote/apiHooks";

import { useClearActiveAction } from "Dashboard/components/WhatsNext/whatsNextStore";
import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionWrapper from "NavBar/components/settings/SettingsOptionWrapper";
import SettingsOptionsWrapper from "NavBar/components/settings/SettingsOptionsWrapper";
import {
  useCloseNavIfOpen,
  useIsDatabaseSetupButtonFlashing,
  useIsProfileFieldsButtonFlashing,
} from "NavBar/stateHooks";
import { menuIconProps } from "NavBar/styleConstants";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTypography from "UI/FnrTypography";
import { navAccentColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import flash from "Utilities/interpolations/flash";

const SettingsContent = ({ setCloseTrigger }) => {
  const closeNavIfOpen = useCloseNavIfOpen();
  const clearActiveAction = useClearActiveAction();

  const isProfileFieldsButtonFlashing = useIsProfileFieldsButtonFlashing();
  const isDatabaseSetupButtonFlashing = useIsDatabaseSetupButtonFlashing();

  const [{ canSeeDatabaseSetup, canSeeProfileFieldsSetup }] = usePermissions();

  if (!canSeeDatabaseSetup && !canSeeProfileFieldsSetup) return null;

  return (
    <SettingsOptionsWrapper>
      {canSeeDatabaseSetup && (
        <SFlashingButton
          $isFlashing={isDatabaseSetupButtonFlashing}
          $flashToColor={addOpacity(navAccentColors.database[0], 0.5)}
          borderRadius={8}
          data-cy="NavBar_HouseholdDatabase"
          onClick={() => {
            window.fnReactBus.goToUrl("/householddatabase/statuses");
            setCloseTrigger({});
            closeNavIfOpen();
            clearActiveAction();
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="wrench fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              Database Setup
            </FnrTypography>
          </SettingsOptionWrapper>
        </SFlashingButton>
      )}
      {canSeeProfileFieldsSetup && (
        <SFlashingButton
          $isFlashing={isProfileFieldsButtonFlashing}
          $flashToColor={addOpacity(navAccentColors.database[0], 0.5)}
          borderRadius={8}
          data-cy="NavBar_ProfileFields"
          onClick={() => {
            window.fnReactBus.goToUrl("/householddatabase/profilefields");
            setCloseTrigger({});
            closeNavIfOpen();
            clearActiveAction();
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="ballot fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              Profile Fields
            </FnrTypography>
          </SettingsOptionWrapper>
        </SFlashingButton>
      )}
    </SettingsOptionsWrapper>
  );
};

SettingsContent.propTypes = { setCloseTrigger: func };

const SFlashingButton = styled(FnrShineButton)`
  ${flash}
`;

export default SettingsContent;
